import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { Alert, Button, Spin } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import ExploreQueryBuilder from '../components/QueryBuilder/CustomQueryBuilder';
import { CubeContext } from '@cubejs-client/react';
import { GET_DASHBOARD_ITEM } from '../graphql/queries';

const ExplorePage = ({ itemId }) => {
  const { cubejsApi } = useContext(CubeContext);
  const { loading, error, data } = useQuery(GET_DASHBOARD_ITEM, {
    variables: {
      id: itemId,
    },
    skip: !itemId,
  });
  const [vizState, setVizState] = useState(null);
  const [shouldExecute, setShouldExecute] = useState(false);
  const [isQueryLoading, setIsQueryLoading] = useState(false);
  const prevVizStateRef = useRef(null);

  const finalVizState =
    vizState ||
    (itemId && !loading && data && JSON.parse(data.dashboardItem.vizState)) ||
    {};

  // Reset shouldExecute when vizState changes (user modified the query)
  useEffect(() => {
    if (prevVizStateRef.current !== null && vizState !== null) {
      // Check if vizState actually changed (deep comparison via JSON stringify)
      const prevStr = JSON.stringify(prevVizStateRef.current);
      const currentStr = JSON.stringify(vizState);
      if (prevStr !== currentStr) {
        // Query was modified, reset execution flag
        setShouldExecute(false);
      }
    }
    prevVizStateRef.current = vizState;
  }, [vizState]);

  // Handle query state changes from ChartRenderer
  const handleQueryStateChange = (queryState) => {
    setIsQueryLoading(queryState?.loading || false);
  };

  // Handle vizState changes - reset execution when query changes
  const handleVizStateChanged = useCallback((newVizState) => {
    setVizState(newVizState);
    // Reset execution flag when query changes
    setShouldExecute(false);
  }, []);

  if (loading) {
    return <Spin />;
  }
  if (error) {
    return <Alert type="error" message={error.toString()} />;
  }
  return (
    <div>
      <ExploreQueryBuilder
        cubejsApi={cubejsApi}
        vizState={finalVizState}
        chartExtra={[
          <Button
            key="run-button"
            type="primary"
            onClick={() => setShouldExecute(true)}
            loading={isQueryLoading}
            style={{ backgroundColor: '#f1543b', borderColor: '#f1543b' }}
          >
            Run Query
          </Button>,
        ]}
        onVizStateChanged={handleVizStateChanged}
        shouldExecute={shouldExecute}
        onQueryStateChange={handleQueryStateChange}
      />
    </div>
  );
};
export default ExplorePage;
